import { Button } from "@globalgiving/components"
import { FC } from "react"
import { AccessDeniedIllustrationIcon, BirdIcon } from "~/icons/png-icons"

export type AccessDeniedProps = {
  userEmail: string
  logout: VoidFunction
  className?: string
}

export const AccessDenied: FC<AccessDeniedProps> = ({ userEmail, logout, className = "" }) => {
  return (
    <div className={`flex flex-col items-center justify-center bg-secondary-navy-darker p-6 ${className}`}>
      <img alt="Access Denied icon" className="mb-5" src={AccessDeniedIllustrationIcon} />
      <h1 className="headline-jumbo mb-3 text-white">Access Denied</h1>
      <div className="relative mb-16 w-full max-w-[420px]">
        <div className="h-[5px] w-full bg-primary-blue" />
        <img alt="Bird icon" className="absolute -bottom-8 left-20 h-16 w-14" src={BirdIcon} />
      </div>
      <p className="body-large mb-4 font-bold text-primary-orange-light">
        Sorry, you aren’t allowed to access this page.
      </p>
      <div className="body-large mb-4 flex flex-col items-center text-center text-white">
        <p className="font-bold">Let’s get you back on track. </p>
        <p className="font-regular">
          You are attempting to access this page as <b className="italic">{userEmail}</b>
        </p>
        <p className="font-regular">If this isn’t the correct login, please switch accounts.</p>
      </div>
      <Button onClick={logout}>Switch Account</Button>
    </div>
  )
}
